import proj4 from "proj4";
import { register } from "ol/proj/proj4";
proj4.defs(
    "EPSG:28992",
    "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs"
);
proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");

register(proj4);

//CSS import
import "ol/ol.css";
import "ol-ext/dist/ol-ext.css";

import Map from "ol/Map";
import OSM from "ol/source/OSM";
import TileLayer from "ol/layer/Tile";
import View from "ol/View";
import GeoJSON from "ol/format/GeoJSON";
import { defaults as interactionDefaults } from "ol/interaction";
import { defaults as controlDefaults } from "ol/control";
import { getCenter } from "ol/extent";

import Fill from "ol/style/Fill";
import { get as getProjection, getTransform } from "ol/proj";
import { Attribution, defaults as defaultControls } from "ol/control";

import Mask from "ol-ext/filter/Mask";
import LayerSwitcherImage from "ol-ext/control/LayerSwitcherImage";
import Bar from "ol-ext/control/Bar";

import store from "../store/Store";
import { HIDE_LEGEND, SHOW_LEGEND, SHOW_SEARCH, HIDE_SEARCH } from "../store/mutation-types";
import { FETCH_CONFIG } from "../store/action-types";
import { GET_LEGEND_SHOW, GET_CONFIG, GET_SEARCH_SHOW } from "../store/getters-types";
import { defaultSelectStyle } from "./styles";
import {
    homeButton,
    zoomButton,
    legendButton,
    filterButton,
} from "./buttons";


import {
    createLayers
} from "./overlayLayers";



import axios from "axios";
import { MapBrowserEvent } from "ol";

var newProj = getProjection("EPSG:28992");

var attribution = new Attribution({
    collapsible: false,
});

const osmLayer = new TileLayer({
    source: new OSM(),
});





var map = new Map({
    interactions: interactionDefaults({
        shiftDragZoom: false,
        pinchRotate: false
    }),
    controls: controlDefaults({
        zoomOptions: {
            zoomInTipLabel: 'Inzoomen',
            zoomOutTipLabel: 'Uitzoomen'
        }
    }),
    //layers: [osmLayer],
    controls: defaultControls({ attribution: false }).extend([attribution]),
    view: new View({
        projection: newProj,
        minResolution: 0.21,
    }),
});





map.addControl(new LayerSwitcherImage({
    mouseover: false
}));

const controlBar = new Bar({ className: 'ol-left', toggleOne: true, group: true });


controlBar.addControl(homeButton);
homeButton.on("change:active", (e, t) => {
    if (e.active) {
        const initialExtent = map.get("initialExtent");
        if (initialExtent) {
            map.getView().fit(initialExtent, { nearest: true });
        }
    }
    homeButton.setActive(false);

    console.log("toggle event " + e.active + " old: " + e.oldValue)
})


controlBar.addControl(zoomButton);
zoomButton.on("change:active", (e) => {

})


controlBar.addControl(legendButton);
legendButton.on("change:active", (e) => {
    if (e.active) {
        store.commit(SHOW_LEGEND);
    } else {
        store.commit(HIDE_LEGEND);
    }

})
store.watch(store.getters[GET_LEGEND_SHOW], legendState => {
    console.log('legend is show: ', legendState)
    legendButton.setActive(legendState);
})


controlBar.addControl(filterButton);
filterButton.on("change:active", (e) => {
    if (e.active) {
        store.commit(SHOW_SEARCH);
    } else {
        store.commit(HIDE_SEARCH);
    }

})

map.addControl(controlBar)

store.watch(store.getters[GET_SEARCH_SHOW], searchState => {
    console.log('search is show: ', searchState)
    filterButton.setActive(searchState);
})





async function initWithConfig(config) {

    const maskFeature = new GeoJSON().readFeature(config.mask);
    var mask = new Mask({
        feature: maskFeature,
        inner: false,
        fill: new Fill({ color: [238, 238, 238, 0.7] }),
    });


    const extent = maskFeature.getGeometry().getExtent();
    //map.getView().setCenter(getCenter(extent));


    const layers = await createLayers(config);
    layers.background.forEach(layer => {
        layer.addFilter(mask);
        map.addLayer(layer)
    })

    layers.addonClientLayers.forEach(layer => {
        map.addLayer(layer)
        map.set(layer.get("name"), layer);
    })
    map.addLayer(layers.vector.vectorLayerBig);
    map.set("vectorLayerBig", layers.vector.vectorLayerBig);
    map.addLayer(layers.vector.vectorLayer);
    map.set("vectorLayer", layers.vector.vectorLayerAll);
    map.addLayer(layers.vector.vectorLayerAll);

    map.set("initialExtent", extent)
    map.getView().fit(extent, { nearest: true });



}



const unregister = store.watch(store.getters[GET_CONFIG], config => {
    // console.log('watched: ', config)
    initWithConfig(config)
    unregister();
})

//store.dispatch(FETCH_CONFIG)

export function getMap() {
    return map;
}
export function setTarget(elem) {
    map.setTarget(elem);
    const initialExtent = map.get("initialExtent");
    if (initialExtent) {
        map.getView().fit(initialExtent, { nearest: true });
    }
}

